module.exports = __webpack_public_path__ + "img/buddy_whiskers-03.76cc34ed.svg";